import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { SubmitButton } from "@/components/ui/button";
import {
  BuildingPayloadSchema,
  buildingPayloadSchema,
  useBuildingCreate,
} from "@/api/building";
import { BuildingFormFields } from "./BuildingFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";
import { FormInfo } from "@/components/ui/form-info";

export function BuildingCreateForm() {
  const form = useForm<BuildingPayloadSchema>({
    resolver: zodResolver(buildingPayloadSchema),
  });
  const { mutate, isPending } = useBuildingCreate();
  const navigate = useNavigate();

  function handleSubmit(values: BuildingPayloadSchema) {
    mutate(
      { data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "Category Bizzpass has been created",
            })
            .then(() => navigate("/master-data/category-bizzpass"));
        },
        onError: (error) => {
          swalError.fire({
            text: error.message,
          });
        },
      },
    );
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <FormInfo
        label="Terms"
        values={[
          "Fill in Dwelling Type U for home-biz, or H for home (according to the homepass manager standard)",
        ]}
      />
      <BuildingFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor
          href="/master-data/category-bizzpass"
          mood="axiata-blue-outline"
        >
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
